import {
    IPcEditorViewableServiceLayer,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/viewable-service-layer.interface';
import {
    EditorViewableServiceLayer,
} from '@src/slide/application/entry/toc/editor/base/service-layer/viewable-service-layer';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import SectionManager from '@src/slide/application/service/section-manager';
import { MasterLayoutStyleService } from '@src/slide/application/service/master-layout-style-service';
import { IEditorAnimPreviewManager } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/editor-state-animation/editor-anim-preview-manager.interface';
import PcScrollService from '@src/slide/application/service/pc-scroll-service';
import { DynamicServiceLoader, IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { IAuthGuideManager } from '@src/slide/application/service/auth-guide-manager/core/auth-guide-manager.interface';
import { authGuideManagerDynamicConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/auth-guide-manager.config';
import { IExportPreferenceService } from '@src/slide/application/service/export-preference-service/core/export-preference-service.interface';
import { ExportPreferenceService } from '@src/slide/application/service/export-preference-service/core';
import { IRightMenuManager } from '@src/slide/application/service/right-menu-manager/core/right-menu-manager.interface';
import { rightMenuManagerDynamicConfig } from './service-dynamic-configs/right-menu-manager.config';
import { IMultiSelectedDashOuterManager } from '@src/slide/application/service/multi-selected-dash-outer/core/multi-selected-dash-outer-manager.interface';
import { getMultiSelectedDashOuterManagerDynamicConfig } from '@src/slide/application/entry/toc/base/service-layer/service-dynamic-configs/multi-selcted-dash-outer-manager.config';
import { IPcCanvasService } from '@src/slide/application/service/canvas-component/core/pc/type';
import PcCanvasService from '@src/slide/application/service/canvas-component/core/pc/pc-canvas-service';
import PcCanvasInjectable from '@src/slide/application/service/canvas-component/inject/pc/pc-canvas-injectable';
import { IPcShortcutKeyManager } from '@src/slide/application/service/shortcut-key/core/interface';
import { IPCProduceBackupManager } from '@src/slide/application/service/produce-backup-manager/core/produce-backup-manager.interface';
import { produceBackupManagerDynamicConfig } from './service-dynamic-configs/produce-backup-manager.config';
import { pcShortcutKeyManagerDynamicConfig } from './service-dynamic-configs/shortcut-key-manager.config';
import { IMobileRemoteControlDropdown } from '@src/slide/application/service/mobile-remote-control-dropdown/core/interface';
import { mobileRemoteControlDynamicConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/mobile-remote-control-dropdown.config';
import { IRemoteControlManager } from '@src/slide/application/service/remote-control-manager/core/interface';
import { remoteControlManagerDynamicConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/remote-control-manager.config';
import { ILiveDropdownService } from '@src/slide/application/service/live-dropdown-service/core/interface';
import { liveDropdownServiceDynamicConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/live-dropdown-service.config';
import { INoteViewMediaSyncManager } from '@src/slide/application/service/note-view-media-sync-manager/core/note-view-media-sync-manager.interface';
import { noteViewMediaSyncManagerDynamicConfig } from '@src/slide/application/entry/toc/base/service-layer/service-dynamic-configs/note-view-media-sync-manager.config';
import { IRemoteMediaSyncManager } from '@src/slide/application/service/remote-media-sync-manager/core/interface';
import { remoteMediaSyncManagerDynamicConfig } from '@src/slide/application/entry/toc/base/service-layer/service-dynamic-configs/remote-sync-media-manager.config';
import RegisterManager from '@src/slide/application/service/register-manager/core/pc';
import { IRegisterManagerInjectable } from '@src/slide/application/service/register-manager/inject/register-manager.interface';
import { RegisterManagerInjectable } from '@src/slide/application/service/register-manager/inject/toc/register-manager-injectable';
import { IPcNoteAreaService } from '@src/slide/application/service/note-area-component/core/pc/type';
import {
    workbenchDynamicServiceConfig,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/workbench-service.config';
import { pcNoteAreaServiceConfig } from '@src/slide/application/entry/toc/base/service-layer/service-dynamic-configs/pc-note-area-service.config';
import InactivityGuideServicePc from '@src/slide/application/service/inactivity-guide/core/inactivity-guide-service-pc';
import { IInactivityGuide } from '@src/slide/application/service/inactivity-guide/core/interface';
import { IPcLeftThumbnailListService } from '@src/slide/application/service/pc-left-thumbnail-list/core/type';
import PcLeftThumbnailListService from '@src/slide/application/service/pc-left-thumbnail-list/core/pc-left-thumbnail-list-service';
import { IInfrastructureBase } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';
import {
    IWorkbenchInjectable,
} from '@src/slide/application/service/workbench-service/inject/worbench-injectable.interface';
import TocPcWorkbenchInjectable from '@src/slide/application/service/workbench-service/inject/toc/pc';
import { PcEditorAreaService } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/edit-pc';
import {
    IPcEditorAreaService,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/edit-pc/pc-content-service.interface';
import { IPcEditorExtensionService } from '@src/slide/application/service/edit-extension/core/editor/pc/interface';
import PcEditorExtensionService from '@src/slide/application/service/edit-extension/core/editor/pc';
import {
    IProduceBackupInjectable,
} from '@src/slide/application/service/produce-backup-manager/inject/produce-backup-injectable.interface';
import ProduceBackupInjectable from '@src/slide/application/service/produce-backup-manager/inject/toc';
import TencentDocsAppService from '@src/slide/application/service/tencent-docs-app-service/core';
import { shouldInitTencentDocsAppService } from '@src/slide/application/service/tencent-docs-app-service/toggle';
import {
    ISimilarityCollectionService,
} from '@src/slide/application/service/similarity-collection/similarity-collection-service.interface';
import { similarityCollectionConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/similarity-collection.config';
import { isDsiReportEnv, isSimilarityEnv } from '@src/slide/infrastructure/module/independent/url-param-env';

import { ICommentManager } from '@src/slide/application/service/comment-manager/core/pc/comment-manager.interface';
import { commentManagerDynamicConfig } from './service-dynamic-configs/comment-manager.config';
import { IDsiReportService } from '@src/slide/application/service/dsi-report-service/interface';
import {
    pcDsiReportServiceDynamicConfig,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/dsi-report-service.config';
import { IImagePreviewService } from '@src/slide/application/service/image-preview/image-preview-service.interface';
import { imagePreviewConfig } from './service-dynamic-configs/image-preview-service.config';

export class PcEditorViewableServiceLayer
    extends EditorViewableServiceLayer implements IPcEditorViewableServiceLayer {
    declare public readonly contentRendererService: IPcEditorAreaService;
    public readonly sectionManager: SectionManager;
    public readonly masterLayoutStyleService: MasterLayoutStyleService;
    public readonly pcScrollService: PcScrollService;
    public readonly authGuideManager: IDynamicService<IAuthGuideManager>;
    public readonly exportPreferenceService: IExportPreferenceService;
    public readonly rightMenuManager: IDynamicService<IRightMenuManager>;
    public readonly shortCutKeyManager: IDynamicService<IPcShortcutKeyManager>;
    public readonly tencentDocsAppService: TencentDocsAppService;
    public readonly multiSelectedDashOuterManager: IDynamicService<IMultiSelectedDashOuterManager>;
    declare public canvasService: IPcCanvasService;
    declare public extensionService: IPcEditorExtensionService;
    public slideListService: IPcLeftThumbnailListService;
    declare public readonly noteAreaService: IDynamicService<IPcNoteAreaService>;
    public readonly produceBackupManager: IDynamicService<IPCProduceBackupManager>;
    public readonly mobileRemoteControlDropdown: IDynamicService<IMobileRemoteControlDropdown>;
    public readonly remoteControlManager: IDynamicService<IRemoteControlManager>;
    public readonly liveDropDownService: IDynamicService<ILiveDropdownService>;
    public readonly remoteMediaSyncManager: IDynamicService<IRemoteMediaSyncManager>;
    public readonly noteViewMediaSyncManager: IDynamicService<INoteViewMediaSyncManager>;
    public readonly inactivityGuideService: IInactivityGuide;
    public readonly similarityCollectionService: IDynamicService<ISimilarityCollectionService>;
    public readonly commentManager: IDynamicService<ICommentManager>;
    public readonly dsiReportService: IDynamicService<IDsiReportService>;
    public readonly imagePreviewService: IDynamicService<IImagePreviewService>;
    private editorAnimPreviewManager: IEditorAnimPreviewManager | undefined;

    public constructor(uiDataService: IUiDataService, infrastructure: IInfrastructureBase) {
        super(uiDataService, infrastructure);
        this.sectionManager = new SectionManager();
        uiDataService.setSectionManagerDelegate(this.sectionManager);
        this.masterLayoutStyleService = new MasterLayoutStyleService();
        this.pcScrollService = new PcScrollService();
        this.authGuideManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(authGuideManagerDynamicConfig);
        this.exportPreferenceService = new ExportPreferenceService();
        this.authGuideManager.onDidInit((authGuideManager) => {
            authGuideManager.setServiceDelegates({
                extensionService: this.extensionService,
                applyAuthService: this.applyAuthService,
            });
        });
        this.commentManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(commentManagerDynamicConfig);
        this.commentManager.onDidInit((commentManager) => {
            commentManager.setServiceDelegates({
                selectionService: this.selectionService,
                rightSideBarService: this.rightSideBarService,
            });
        });
        this.shortCutKeyManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(pcShortcutKeyManagerDynamicConfig);
        this.shortCutKeyManager.onDidInit((shortCutKeyManager) => {
            shortCutKeyManager.setServicesDelegates({
                selectionService: this.selectionService,
                uiDataService,
                editorInstanceService: this.editorInstanceService,
                userPriviledgeService: this.userPriviledgeService,
                editingStateManager: this.editingStateManager,
                tipsManager: this.tipsManager,
                accessibilityManager: this.accessibilityManager,
                playManager: this.playManager,
                sectionManager: this.sectionManager,
                linkManager: this.linkManager,
                toolbarStateManager: this.toolbarStateManager,
                printService: this.printService,
                commentManager: this.commentManager,
            });
            shortCutKeyManager.init();
        });
        this.rightMenuManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(rightMenuManagerDynamicConfig);
        this.rightMenuManager.onDidInit((rightMenuManager) => {
            rightMenuManager.setServicesDelegate({
                selectionService: this.selectionService,
            });
        });
        this.multiSelectedDashOuterManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(getMultiSelectedDashOuterManagerDynamicConfig(
                this.selectionService,
                this.editingStateManager,
            ));
        this.mobileRemoteControlDropdown = DynamicServiceLoader.getInstance()
            .registerDynamicService(mobileRemoteControlDynamicConfig);
        this.mobileRemoteControlDropdown.onDidInit((mobileRemoteControlDropdown) => {
            mobileRemoteControlDropdown.setServiceDelegates({
                extensionService: this.extensionService,
                slideRenderStateManager: this.slideRenderStateManager,
                remoteControlManager: this.remoteControlManager,
                liveManager: this.liveManager,
            });
        });
        this.remoteControlManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(remoteControlManagerDynamicConfig);
        this.initPcCanvasService();
        this.initSlideListService();
        this.produceBackupManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(produceBackupManagerDynamicConfig);
        this.produceBackupManager.onDidInit((produceBackupManager) => {
            produceBackupManager.setServiceDelegates({
                exportManager: this.exportManager,
                fontManager: this.fontManager,
            });
            produceBackupManager.setInject(this.createProduceBackupInjectable());
        });
        this.liveDropDownService = DynamicServiceLoader.getInstance()
            .registerDynamicService(liveDropdownServiceDynamicConfig);
        this.liveDropDownService.onDidInit((liveDropDownService) => {
            liveDropDownService.setServiceDelegates({
                extensionService: this.extensionService,
                slideRenderStateManager: this.slideRenderStateManager,
                remoteControlManager: this.remoteControlManager,
                liveManager: this.liveManager,
            });
        });
        this.remoteMediaSyncManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(remoteMediaSyncManagerDynamicConfig);
        this.remoteMediaSyncManager.onDidInit((remoteMediaSyncManager) => {
            remoteMediaSyncManager.setServiceDelegates({
                mediaManager: this.mediaManager,
                uiDataService,
                liveManager: this.liveManager,
            });
        });
        this.noteViewMediaSyncManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(noteViewMediaSyncManagerDynamicConfig);
        this.noteAreaService = DynamicServiceLoader.getInstance()
            .registerDynamicService(pcNoteAreaServiceConfig);
        this.noteAreaService.onDidInit((pcNoteAreaService) => {
            pcNoteAreaService.setViewerServiceDelegates({
                selectionService: this.selectionService,
                userPriviledgeService: this.userPriviledgeService,
                noteAreaManager: this.noteAreaManager,
                tipsManager: this.tipsManager,
                canvasService: this.canvasService,
                playManager: this.playManager,
                fontManager: this.fontManager,
            });
        });
        this.workbenchService = DynamicServiceLoader.getInstance()
            .registerDynamicService(workbenchDynamicServiceConfig);
        this.workbenchService.onDidInit((workbenchService) => {
            workbenchService.setWorkbenchInject(this.createWorkbenchInjectable());
        });
        this.inactivityGuideService = new InactivityGuideServicePc({
            produceBackupManager: this.produceBackupManager,
        });
        if (this.shouldInitTencentDocsAppService()) {
            this.tencentDocsAppService = new TencentDocsAppService(this.slideRenderStateManager);
        }
        if (isSimilarityEnv()) {
            // 相似度对比分析平台跑版时才需要挂载此service
            this.similarityCollectionService = DynamicServiceLoader.getInstance()
                .registerDynamicService(similarityCollectionConfig);
            this.similarityCollectionService.onDidInit((similarityCollectionService) => {
                similarityCollectionService.setServiceDelegates({
                    uiDataService: this.uiDataService,
                    pcEditorAreaService: this.contentRendererService,
                    editAreaCanvasSizeManager: this.editAreaCanvasSizeManager,
                    slideRenderStateManager: this.slideRenderStateManager,
                });
            });
        }

        if (isDsiReportEnv()) {
            this.dsiReportService = DynamicServiceLoader.getInstance()
                .registerDynamicService(pcDsiReportServiceDynamicConfig);
            this.dsiReportService.onDidInit((dsiReportService) => {
                dsiReportService.setServiceDelegate({
                    uiDataService,
                    selectionService: this.selectionService,
                    slideRenderStateManager: this.slideRenderStateManager,
                });
            });
        }

        this.imagePreviewService = DynamicServiceLoader.getInstance().registerDynamicService(imagePreviewConfig);
    }

    public getEditorAnimPreviewManager = (): IEditorAnimPreviewManager | undefined => this.editorAnimPreviewManager;

    public setEditorAnimPreviewManager(manager: IEditorAnimPreviewManager): void {
        this.editorAnimPreviewManager = manager;
    }

    protected createExtensionService(): IPcEditorExtensionService {
        return new PcEditorExtensionService();
    }

    protected initRegisterManager(): void {
        this.registerManager = new RegisterManager(this.createRegisterManagerInjectable());
    }

    protected createRegisterManagerInjectable(): IRegisterManagerInjectable {
        return new RegisterManagerInjectable();
    }

    protected createWorkbenchInjectable(): IWorkbenchInjectable {
        return new TocPcWorkbenchInjectable();
    }

    protected createCanvasRendererService(): IPcEditorAreaService {
        return new PcEditorAreaService();
    }

    protected createProduceBackupInjectable(): IProduceBackupInjectable {
        return new ProduceBackupInjectable();
    }

    protected shouldInitTencentDocsAppService(): boolean {
        return shouldInitTencentDocsAppService;
    }

    /**
     * 初始化pc canvas service
     */
    private initPcCanvasService() {
        this.canvasService = new PcCanvasService(new PcCanvasInjectable());
        this.canvasService.setViewerServiceDelegates({
            uiDataService: this.uiDataService,
            masterLayoutStyleService: this.masterLayoutStyleService,
            editAreaCanvasSizeManager: this.editAreaCanvasSizeManager,
            editingStateManager: this.editingStateManager,
            editorInstanceService: this.editorInstanceService,
            selectionService: this.selectionService,
            tipsManager: this.tipsManager,
            userPriviledgeService: this.userPriviledgeService,
            pcScrollService: this.pcScrollService,
            multiSelectedDashOuterManager: this.multiSelectedDashOuterManager,
            linkManager: this.linkManager,
            toolbarStateManager: this.toolbarStateManager,
            watermarkManager: this.watermarkManager,
            pcEditorAreaService: this.contentRendererService,
        });
    }

    private initSlideListService() {
        this.slideListService = new PcLeftThumbnailListService();
        this.slideListService.setViewerServiceDelegates({
            uiDataService: this.uiDataService,
            selectionService: this.selectionService,
            userPriviledgeService: this.userPriviledgeService,
            sectionManager: this.sectionManager,
            slideRenderStateManager: this.slideRenderStateManager,
            tipsManager: this.tipsManager,
            imgLoaderManager: this.imgLoaderManager,
            editingStateManager: this.editingStateManager,
            rightMenuManager: this.rightMenuManager,
            masterLayoutStyleService: this.masterLayoutStyleService,
        });
    }
}
